import './App.css';
import Layout from "./components/Layout/Layout";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/font.css';
import './assets/css/style.css';

function App() {
  return (
    <div className="App">
      <Layout/>
    </div>
  );
}

export default App;
